import { observable, computed, action, makeObservable } from 'mobx';

import { history } from 'helpers/History';
import { http } from '../../helpers/HttpApi';
import RegistrationModel from './Registration';
import { Permissions } from 'helpers';
import { RoutePaths } from 'helpers/constants/RoutePaths';
import { StoreModel } from 'models/Index';
import { KioskInteractionData } from 'interfaces';
import { PermissionModel } from '../shared/PermissionModel';
import { getAbsoluteUrl } from 'helpers/Uri';

export interface INavigation {
    next?: {
        onClick: () => void;
        disable?: boolean;
    };
    back?: {
        onClick: () => void;
        disable?: boolean;
    };
}

export default class AdminModel {
    constructor(root: StoreModel) {
        this.root = root;
        this.registration = new RegistrationModel(root, this);
        makeObservable(this);
    }

    @observable public registration: RegistrationModel;

    @observable public accessCode: string = '';
    @observable public hasKioskSetupPermission: boolean;
    @observable public hasCashCollectionPermission: boolean;

    public isLoggedIn: boolean = false;
    public userName?: string = '';

    root: StoreModel;

    @action async login() {
        const response = await http.get<KioskInteractionData>(
            '/api/admin/login'
        );

        this.isLoggedIn = true;
        this.userName = response.data.userName;

        // Login to different database? clear previous registration
        if (this.root.accessCode !== response.data.accessCode) {
            await this.root.clearRegistration();
        }

        // Reapply registration if it exists
        await this.root.initShellValues(response.data);
    }

    @action async logout() {
        const returnUrl = window.location.href.includes(
            RoutePaths.CashCollection
        )
            ? getAbsoluteUrl(RoutePaths.CashCollection)
            : getAbsoluteUrl(RoutePaths.IdleScreen);

        const response = await http.get('/api/admin/logout', {
            params: { returnUrl },
        });

        this.isLoggedIn = false;

        window.location = response.headers.location;

        // Not continue code execution and just wait when redirect will happen
        await new Promise(() => {});
    }

    @action async retrievePermissions() {
        const permissionsResponse = await http.get<Array<PermissionModel>>(
            '/api/permissions/admin'
        );
        const permissions = permissionsResponse.data;
        this.hasKioskSetupPermission =
            permissions?.find((p) => p.name === Permissions.KioskSetup)
                ?.enabled ?? false;
        this.hasCashCollectionPermission =
            permissions?.find((p) => p.name === Permissions.CashCollection)
                ?.enabled ?? false;
    }

    @computed get navigationMainPage() {
        return {
            collection: {
                onClick: () => {
                    history.push(
                        `${RoutePaths.CashCollection}/${history.location.search}`
                    );
                },
            },
            registration: {
                onClick: () => {
                    history.push(
                        `${RoutePaths.Registration}/${history.location.search}`
                    );
                },
            },
        };
    }
}
